import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import React from 'react';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import cardStyles from './cardStyles';
import AccountName from './AccountName';
import GLBalance from './GLBalance';
import FactaBalance from './FactaBalance';
import TaskReadOnlyDetail from './TaskReadOnlyDetail';
import TaskActionDetail from './TaskActionDetail';
import AccountUnScheduledCountInfo from './AccountUnScheduledCountInfo';

interface Props {
  active: boolean;
  accountName: string;
  loading: boolean;
  glBalance: number;
  openingBalance: number;
  action: () => void;
  onCurrencyNavigation: () => void;
  amortizationUnPostedAmount: number;
  unScheduleAssetsCount: number;
}

const CurrentMonthScheduledCard = ({
  active,
  accountName,
  loading,
  glBalance,
  openingBalance,
  action,
  onCurrencyNavigation,
  amortizationUnPostedAmount,
  unScheduleAssetsCount,
}: Props) => {
  const classes = cardStyles();
  return (
    <Card
      className={clsx(classes.card, { [classes.active]: active })}
    >
      <CardContent>
        <AccountUnScheduledCountInfo
          unScheduleAssetsCount={unScheduleAssetsCount}
        />
        <AccountName accountName={accountName} />
        <GLBalance glBalance={glBalance} loading={loading} />
        <FactaBalance balance={openingBalance} />
      </CardContent>
      <CardActions className={classes.padding15}>
        <TaskReadOnlyDetail
          name="Prepaids Scheduled"
          completed
          amount={0}
          onCurrencyNavigation={onCurrencyNavigation}
          enableCurrencyNavigation
        />
        <TaskActionDetail
          name="Post Amortization"
          amount={amortizationUnPostedAmount}
          action={action}
        />
        <TaskReadOnlyDetail
          name="Amortization Posted"
          amount={0}
        />
      </CardActions>
    </Card>
  );
};

export default React.memo(CurrentMonthScheduledCard);
